
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.055 15l-.293.405a.5.5 0 00.793-.405h-.5zm-4.077-2.955l.294-.405-.294.405zm7.647-5.506a.5.5 0 00-1 0h1zM1.5 9.854V3.875h-1v5.98h1zm10.625 1.5h-.07v1h.07v-1zm-1.57 1.5V15h1v-2.146h-1zm.794 1.741L7.272 11.64l-.587.81 4.077 2.955.587-.81zm-4.957-3.24H2.999v1h3.393v-1zM3 2.374h8.796v-1H3v1zm10.625 4.164v3.315h1V6.54h-1zm-1.57 4.815a1.5 1.5 0 00-1.5 1.5h1a.5.5 0 01.5-.5v-1zM.5 9.854a2.5 2.5 0 002.5 2.5v-1a1.5 1.5 0 01-1.5-1.5h-1zm11.625 2.5a2.5 2.5 0 002.5-2.5h-1a1.5 1.5 0 01-1.5 1.5v1zm-4.853-.714a1.5 1.5 0 00-.88-.286v1a.5.5 0 01.293.096l.587-.81zM1.5 3.875a1.5 1.5 0 011.5-1.5v-1a2.5 2.5 0 00-2.5 2.5h1z"}}),_c('circle',{attrs:{"cx":"12.25","cy":"1.875","r":"1.875"}})])
          )
        }
      }
    